import { OpenInBrowserOutlined } from "@material-ui/icons";
import React from "react";
import { FormattedMessage } from "react-intl";
import { GlobalAppIssue } from "./global-app-issue";
import IssueTitle from "./issue-title";

const BrowserIsValidIssue: FC<{}> = () => {
  return (
    <GlobalAppIssue icon={<OpenInBrowserOutlined />}>
      <IssueTitle>
        <FormattedMessage
          id="globalAppIssue.browserOutOfDate.title"
          defaultMessage="Please upgrade to get the best experience"
        />
      </IssueTitle>
      <FormattedMessage
        id="globalAppIssue.browserOutOfDate.description"
        defaultMessage="Your version of Chrome is limiting the Elephant features you can access. Please click <link>here</link> to upgrade"
        values={{
          link: (
            str:
              | boolean
              | React.ReactChild
              | React.ReactFragment
              | React.ReactPortal,
          ) => (
            <a href="https://support.google.com/chrome/answer/95414?hl=en&co=GENIE.Platform%3DAndroid&oco=1">
              {str}
            </a>
          ),
        }}
      />
    </GlobalAppIssue>
  );
};

export default BrowserIsValidIssue;
